module.exports = __webpack_public_path__ + "img/StarterPlus.9742e427.png";